import script from "./UploadIDModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadIDModal.vue?vue&type=script&setup=true&lang=ts"

import "./UploadIDModal.vue?vue&type=style&index=0&id=aa8e83e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa8e83e0"]])

export default __exports__